import { LineItem, Package, Plan } from '@/common/models';

import { EntityAvailsDataHelper } from './EntityAvailsDataHelper';
import { LineItemAvailsDataHelper } from './LineItemAvailsDataHelper';
import { PackageAvailsDataHelper } from './PackageAvailsDataHelper';
import { PlanAvailsDataHelper } from './PlanAvailsDataHelper';

export function createEntityAvailsDataHelper(entity: LineItem | Plan | Package): EntityAvailsDataHelper {
  if (entity instanceof LineItem) {
    return new LineItemAvailsDataHelper(entity);
  }
  if (entity instanceof Plan) {
    return new PlanAvailsDataHelper(entity);
  }
  if (entity instanceof Package) {
    return new PackageAvailsDataHelper(entity);
  }
  throw new Error('Unsupported entity type');
}
